module.exports = __webpack_public_path__ + "static/mini1-ec449044fc7de7e8b7f3be6bb85392eb.png";